import { CheckBox } from 'react-native-web';
import { CustomCheckboxProps } from "./CustomCheckboxTypes";

// See https://necolas.github.io/react-native-web/docs/checkbox/
export const CustomCheckbox = (props: CustomCheckboxProps) => {
  return (
    <CheckBox
      {...props}

      // Resolve the warning:
      //   Warning: A component is changing an uncontrolled input to be controlled.
      //   This is likely caused by the value changing from undefined to a defined
      //   value, which should not happen. Decide between using a controlled or
      //   uncontrolled input element for the lifetime of the component. More info:
      //   https://reactjs.org/link/controlled-components
      value={props.value === undefined ? false : props.value}
    />
  );
};
